<template lang="pug">
b-container.dsg-page(fluid)
    .dsg-page-header
        div
            h1.dsg-page-title
                Icon(icon="bi:calendar2-week")
                | Weekly Schedule
            p.dsg-page-subtitle Sessions scheduled for the current week

    .dsg-table-wrap
        b-table.dsg-table(
            :fields="tableFields"
            :items="listWeeklySchedule"
            responsive
            hover
            show-empty
        )
            template(#empty="scope")
                .dsg-empty(v-if="isFetchingAdminDashboardData")
                    b-spinner(variant="primary")
                .dsg-empty(v-else)
                    Icon.dsg-empty-icon(icon="teenyicons:calendar-no-access-outline" width="48")
                    p.mb-0 No active schedules this week
            template(#cell(scheduleName)="data")
                span.dsg-link(
                        v-b-tooltip.hover :title="`Click to view ${data.item.crb5c_sessionname} session`"
                        @click="redirectToWeeklySchedulePowerApps(data.item.crb5c_fow_sessionid)"
                    ) {{ data.item.crb5c_sessionname }}
            template(#cell(Date)="data")
                span {{ formatDate(data.item.crb5c_date) }}
            template(#cell(Duration)="data")
                span {{ data.item.formattedDuration }}

    p.dsg-count Total weekly schedule: {{ listWeeklySchedule.length }}
</template>


<script>
// import Pagination from './admin-component/Pagination.vue';
import dayjs from 'dayjs';
import { mapState } from 'vuex';
import { Icon } from '@iconify/vue2';
import { ADMIN_DASHBOARD_NAMESPACE } from '../../store/Modules/AdminDashboard/types-admin-dashboard'


export default{
    components: {
        Icon,
    },
    data(){
        return{
            tableFields: [
                { 
                    key: "scheduleName",
                    label: "Schedule Name",
                },
                "Date",
                "Duration",
                // { 
                //     key: "checkInEnrolled",
                //     label: "Checked In / Enrolled",
                // },
            ],
            schedules: [],
            scheduleDB: [],
            inputSearchItemList: '',
            currentPage: 0,
            pageSize: 4,
            visibleList: [],
            
        }
    },
    computed: {
        ...mapState({
            listWeeklySchedule: state => (state[ADMIN_DASHBOARD_NAMESPACE].adminDashboard.listWeeklySchedule),
            isFetchingAdminDashboardData: state => (state[ADMIN_DASHBOARD_NAMESPACE].adminDashboard.isFetchingAdminDashboardData),
        }),
        scheduleList(){
            if(this.inputSearchItemList.trim().length > 0){
                return this.schedules.filter(schedule => {
                    return schedule.scheduleName.some(item => {
                        return item.name.toLowerCase().includes(this.inputSearchItemList.trim().toLowerCase());
                    });
                })
            }else{
                return this.schedules
            }
        },
        weekInYear(){
            const date = dayjs();
            return date.week();
        }
    },
    beforeMount: function(){
        this.updateVisibleList()
    },
    methods: {
        formatDate(rawIsoStringDate){
            return dayjs(rawIsoStringDate).format('DD MMM YYYY');
        },
        updatePage(pageNumber){
            this.currentPage = pageNumber
            this.updateVisibleList()
        },
        updateVisibleList(){
            this.visibleList = this.schedules.slice(this.currentPage * this.pageSize, (this.currentPage * this.pageSize) + this.pageSize);

            // if have 0 list client, go back a page
            if(this.visibleList.length === 0 && this.currentPage > 0){
                this.updatePage(this.currentPage - 1)
            }
        },
        backAdminHomepage() {
            this.$router.push({ path: '/adminhomepage' })
        },  
        moveToHomePage(){
            this.$router.push({ path: "/" })
        },
        redirectToWeeklySchedulePowerApps(crb5c_fow_sessionid){
            const BASE_URL = `https://${this.$store.state.logindata.DATAVERSE_DOMAIN}`;
            const weeklyScheduleUrl = `${BASE_URL}/main.aspx?appid=d951a007-cf7a-ed11-81ac-000d3a85cc97&pagetype=entityrecord&etn=crb5c_fow_session&id=${crb5c_fow_sessionid}`;
            
            window.open(weeklyScheduleUrl, '_blank');
            
        },
    },
}
</script>

<style scoped>
/* Weekly schedule uses shared .dsg-* theme (admin-theme.css) */
</style>